import axios from 'axios';
import type {
  ContributionProjetDTO,
  CreerContributionInput,
  ModifierContributionInput,
  ApiResponse,
} from '../../application/dto/dtos';

const BASE = '/api/v1/paie/contributions-projet';

export const contributionsProjetApi = {
  listerParEmploye: (idEmploye: string): Promise<ApiResponse<ContributionProjetDTO[]>> =>
    axios.get(`${BASE}/employe/${idEmploye}`).then(r => r.data),

  listerParProjet: (idProjet: string): Promise<ApiResponse<ContributionProjetDTO[]>> =>
    axios.get(`${BASE}/projet/${idProjet}`).then(r => r.data),

  creer: (data: CreerContributionInput): Promise<ApiResponse<ContributionProjetDTO>> =>
    axios.post(BASE, data).then(r => r.data),

  modifier: (idContribution: string, data: ModifierContributionInput): Promise<ApiResponse<ContributionProjetDTO>> =>
    axios.put(`${BASE}/${idContribution}`, data).then(r => r.data),

  supprimer: (idContribution: string): Promise<ApiResponse<void>> =>
    axios.delete(`${BASE}/${idContribution}`).then(r => r.data),
};
